module.exports = __webpack_public_path__ + "img/zach.1feee907.png";